import { insureShieldImg2 } from "@/utils/images";
import Image from "next/image";
import React from "react";
import { Col, Container, Row } from "reactstrap";

import classes from "@/styles/insureshield/terms.module.css";

const Terms = () => {
  return (
    <main className={classes.container}>
      <section className="my-5">
        <Container className={classes.hero}>
          <Image
            src={insureShieldImg2}
            alt="UPS Capital"
            height={100}
            width={200}
          />
          <h6 className={classes.heroHeading}>
            TERMS AND CONDITIONS OF SERVICE AND EXPLANATION OF COVERAGE
          </h6>
          <hr />
        </Container>
      </section>
      <section className="my-5">
        <Container>
          <p>
            These Terms and Conditions of Service and Explanation of Coverage (
            <b>T{"&"}Cs</b>) are an integral part of the transactional cargo
            insurance program (<b>Program</b>) established by UPS Capital
            Insurance Agency, Inc. (<b>we</b> or <b>UPSCIA</b>) for ShipVista (
            <b>Channel Partner</b>). As used herein, the term&nbsp;
            <b>Program Partner</b> means Channel Partner and any customer of
            Channel Partner that participates in the Program pursuant to an
            agreement with UPSCIA. To contact UPSCIA, see the “Contact Us”
            information in Section 19.
          </p>

          <br />

          <ol className="numbered">
            <li>
              <b>REVIEW AND ACCEPTANCE:</b>&nbsp; You (<b>you</b> or{" "}
              <b>End User</b>) should fully review and understand these T{"&"}Cs
              before you request to participate in the Program with respect to
              any shipment of goods. In particular, you should ensure that your
              shipments are eligible for coverage and that you understand the
              terms of protection offered under the Policies (defined below).
              Your acceptance of these T{"&"}Cs is a condition precedent for
              your goods to be protected under a Policy. In addition, you should
              fully review and understand each of the following before you
              request to participate in the Program with respect to any shipment
              of goods: the UPS Capital Group Technology Agreement (the current
              version of which is available at{" "}
              <a
                rel="noreferrer"
                target="_blank"
                href="https://upscapital.com/technology-agreement/"
              >
                https://upscapital.com/technology-agreement/
              </a>
              ), and the UPS Capital Privacy Notice (the current version of
              which is available at{" "}
              <a
                rel="noreferrer"
                target="_blank"
                href="https://upscapital.com/privacy-notice/"
              >
                https://upscapital.com/privacy-notice/
              </a>
              ) (together with these T{"&"}Cs, collectively, the{" "}
              <b>Acceptance Documents</b>). We may update or otherwise modify
              these T{"&"}Cs and the other Acceptance Documents from time to
              time in our discretion (without notice to you). Each time that you
              (a) elect to insure a shipment of goods (whether in the form of a
              specific election to insure specific goods or a general election
              to insure all or a designated portion of the goods purchased from
              or through a Program Partner from time to time) or (b) purchase or
              book a shipment for goods that are sold on the condition of being
              insured (or that purport to be sold on an insured basis) pursuant
              to the Program, you will be deemed to have accepted and agreed to
              the versions of the Acceptance Documents in effect at the time the
              insurance was requested or deemed to be requested (or, if the
              request or deemed request relates to a general election to insure
              future shipments of goods, the versions of such Acceptance
              Documents in effect at the time of booking of the applicable
              shipment of goods). For the avoidance of doubt, if the settings or
              preferences for your account with a Program Partner include a
              general election for purchased goods to be insured pursuant to the
              Program, then you will be deemed to have elected to insure goods
              purchased from or through a Program Partner until such time as you
              change that election.
            </li>
            <li>
              <b>OFFER TO INCLUDE GOODS UNDER POLICY:</b>&nbsp; Channel Partner
              or another Program Partner has offered you the opportunity to
              participate in the Program by including your eligible shipments of
              goods under one or more cargo insurance policies (<b>Policies</b>)
              issued through UPSCIA to either Channel Partner or UPS Capital
              Corporation, an affiliate of UPSCIA (<b>UPSC</b>). You shall be
              deemed to have requested to insure goods under a Policy at any
              time that you purchase goods that are sold on the condition of
              being insured (or that purport to be sold on an insured basis)
              pursuant to the Program. Your election to include your goods under
              any Policy applies only the shipment(s) you have elected to
              include under the applicable Policy and is entirely optional. This
              offer is exclusive to you. You are not permitted to offer any
              other party the opportunity to participate in the Program and any
              such offer will be null and void. No other party may participate
              in the Program except pursuant to a program agreement (or
              substantially similar agreement proposed by UPSCIA) between such
              party and UPSCIA. The Program may be terminated at any time
              without prior notice to you.
            </li>
            <li>
              <b>CERTAIN END USERS AND SHIPMENTS NOT ELIGIBLE:</b>&nbsp; End
              Users located or based outside of the United States are not
              eligible to participate in the Program. End Users who are
              individual persons are not eligible to participate in the Program
              except to the extent acting on behalf of a corporate or similar
              business entity for a business purpose. No personal shipments or
              shipments with contents unrelated to the business purposes of an
              End User will be protected under any Policy regardless of
              commodity type.
            </li>
            <li>
              <b>NO RIGHTS UNDER THE POLICIES:</b>&nbsp; This offer is not
              intended to provide insurance directly to you. You are neither an
              insured nor an additional insured nor do you have any other rights
              under any Policy. In the event of a loss covered under an
              applicable Policy, any resulting claim payment may be directed to
              you by Channel Partner as a loss payee and only to the extent of
              your interest in the insured shipment.
            </li>
            <li>
              <b>POLICY DETAILS:</b>&nbsp; All Policies for the Program are
              underwritten by an authorized insurance company (<b>Insurer</b>)
              and produced by UPSCIA. UPSCIA has prepared these T{"&"}Cs in part
              to summarize coverage terms under the Policies for your benefit in
              your capacity as a prospective loss payee. UPSCIA, UPSC, Channel
              Partner, and/or other parties may receive financial compensation
              in connection with the Program. You may request a copy of the
              Policies from Channel Partner or UPSCIA. Please consult the
              Policies for their exact terms and conditions.
            </li>
            <li>
              <b>NO BROKER OR CUSTOMER RELATIONSHIP WITH UPSCIA: </b>&nbsp; You
              acknowledge that we are an insurance broker for Channel Partner
              and that, except as expressly described in these T{"&"}Cs, we have
              no contractual relationship with you and do not serve as your
              broker, agent or other representative. We may communicate or
              otherwise interact with you from time to time to facilitate
              Channel Partner’s administration of the Program (including any
              administration occurring through another Program Partner),
              including by delivering invoices to you for insurance-related
              fees; receiving payments from you; receiving from you, and
              administering, claims under the Program; and delivering claim
              payments to you at the request of Channel Partner. No such
              communications or interactions shall be deemed to create a broker
              or customer relationship between you and UPSCIA or our affiliates.
            </li>
            <li>
              <b>PRIVACY NOTICE:</b>&nbsp; USPCIA and its affiliates will need
              to collect and process personal data from time to time in
              connection with your election to participate in the Program,
              including with respect to the adjustment and payment of claims
              made under any Policy. For details about how UPSCIA and its
              affiliates process personal data, please see the UPS Capital
              Privacy Notice located at&nbsp;
              <a
                rel="noreferrer"
                target="_blank"
                href="https://upscapital.com/privacy-notice/"
              >
                https://upscapital.com/privacy-notice/
              </a>
              . By accepting these T{"&"}Cs, you warrant that (i) you have
              obtained any personal data provided to UPSCIA (whether directly or
              through a Program Partner) lawfully, (ii) you are authorized to
              provide such data to UPSCIA and its affiliates, and (iii) you have
              duly informed any of your customers whose personal data is
              provided to UPSCIA or its affiliates in connection Program (e.g.
              in connection with the submission of a claim under a Policy) that
              UPSCIA and its affiliates will process such data in accordance
              with the above-linked UPS Capital Privacy Notice in effect at the
              time of collection.
            </li>
            <li>
              <b>REQUESTING COVERAGE UNDER A POLICY:</b>&nbsp; To request
              coverage under a Policy for any shipment, you must provide
              specific information regarding the shipment to the applicable
              Program Partner and/or UPSCIA and elect to insure the shipment, in
              each case in accordance with procedures established by Channel
              Partner and the applicable Program Partner and approved by UPSCIA
              from time to time. UPSCIA reserves the right to refuse coverage
              for certain shipments.
            </li>
            <li>
              <b>
                COMPLIANCE WITH TRANSPORTATION CARRIER TERMS AND CONDITIONS:
              </b>
              &nbsp; Your compliance with the transportation carrier’s shipping
              terms and conditions in effect at time of shipment shall be a
              condition precedent for coverage under the Policies. In accepting
              the transportation carrier’s shipping terms and conditions and
              these T{"&"}Cs, you do so on behalf of yourself and on behalf of
              all parties with any interest in the goods.
            </li>
            <li>
              <b>ELIGIBLE CONVEYANCES AND ROUTES:</b>&nbsp; Ground and air
              shipments are eligible for coverage under the Policies.
              International and domestic shipments are eligible for coverage
              under the Policies so long as you reside in the United States,
              provided that coverage will be null and void whenever it (or any
              related payment or other transaction) would be in violation of any
              U.S. economic or trade sanctions.
            </li>
            <li>
              <b>COVERAGE LIMITS, INSURING TERMS, DEDUCTIBLES AND FEES:</b>
              &nbsp; The Policies may provide for different insuring terms,
              coverage limits, deductibles, and fees depending upon the
              commodity types being shipped.{" "}
              <b>
                <u>
                  Note that motorized vehicles are only eligible for “Free of
                  Particular Average” or “FPA” coverage, meaning that only the
                  risk of total loss is covered in most instances for such
                  commodity types and not the risk of partial loss or damage.
                </u>
              </b>{" "}
              If you are asked to indicate the type of commodity being shipped,
              when requesting coverage for shipments containing multiple
              commodity types, choose the commodity representing the majority of
              items in the shipment, but be advised that each specific commodity
              type will remain subject to all the insuring terms and
              restrictions applicable to that specific commodity type.
              Notwithstanding the foregoing, coverage under the Policies is
              limited in all events to $10,000 per any one Parcel conveyance or
              occurrence, whichever is less, and coverage under the Policies is
              limited in all events to $1,000 per any one Postal conveyance or
              occurrence, whichever is less.
            </li>
            <li>
              <b>SCOPE OF COVERAGE:</b>&nbsp; The Policies provide coverage for
              physical loss and/or damage to package contents in the course of
              transit, subject to insuring conditions, limitations and
              exclusions. The Policies provide no coverage for delay in transit
              or for consequential or indirect losses. The scope of coverage
              under the Policies is summarized as follows:
              <ol type="a" className="lettered">
                <li>
                  <b>Duration:</b>&nbsp; Coverage under any Policy commences
                  upon the shipment of cargo leaving the origin of the insured
                  transport and continues during the ordinary course of the
                  transit, including customary transshipment, until the sooner
                  of: (i) delivery to the final destination of the insured
                  transport; or (ii) fifteen days after the shipment arrives at
                  the destination port, airport or other hub, if not yet
                  delivered to final destination of the insured transport (or
                  thirty days if the destination to which the goods are insured
                  is outside the limits of the port). You acknowledge that
                  coverage under a Policy may terminate before final delivery
                  and that you are responsible for arranging and facilitating
                  prompt final delivery of the shipment after its arrival at the
                  destination port, airport or other hub.
                </li>
                <li>
                  <b>Valuation:</b>&nbsp; You should declare a value for new
                  goods of invoice cost plus freight. You should declare a value
                  for used or refurbished goods of actual cash value plus
                  freight. In all cases, the claim payment will not exceed the
                  lesser of verified valuation of the goods or the amount
                  declared for insurance purposes, in each case less any
                  applicable deductible. Loss valuations are subject to
                  substantiation, and no Policy is an agreed value policy.
                  <br />
                  <br />
                  <b>
                    <u>Notice of Co-Insurance Penalty:</u>
                  </b>
                  &nbsp; In the event that you declare a value that is less than
                  the valuation provided for above, you will be compensated for
                  a proportion of your loss based on the value that you declared
                  and not based on any other valuation. For example, if you
                  declared a value of $500 for a shipment of goods with an
                  actual value of $1,000 (i.e., you declare a value for the
                  goods equal to 50% of the actual value of the goods), and if
                  an insurable event occurred which resulted in a loss with a
                  value of $400, then the Policy for such goods would only pay
                  50% of the loss value associated with such insurable event, or
                  $200.
                </li>
                <li>
                  <b>Excluded Commodities and Shipments:</b>&nbsp; Not all
                  commodities are eligible for coverage under the Policies. Each
                  Policy specifically excludes the following commodities from
                  coverage: contraband, illicit goods; accounts receivable; fish
                  meal; nuclear fuel and substances; fireworks, explosive
                  agents, fire-starting devices or aids; live plants, animals
                  and insects, human tissues or organs, human remains, corpses
                  or body parts; bullion; stamps; cash; currency; money; coins;
                  deeds; notes; securities; bills; evidence of debt; precious
                  stones; and fine arts and jewelry. Commodity-specific coverage
                  terms may apply.
                </li>
                <li>
                  <b>Excluded Risks:</b>&nbsp; As with all insurance, coverage
                  under the Insurance Policy is subject to exclusions which
                  specifically include:
                  <br />
                  <br />
                  <Row>
                    <Col xs={12} md={6}>
                      <ul>
                        <li>
                          war risks for U.S. (continental) domestic shipments;
                        </li>
                        <li>radioactive contamination;</li>
                        <li>
                          delay, whether or not caused by an insured peril;
                        </li>
                        <li>
                          temperature variation, whether or not caused by an
                          insured peril;
                        </li>
                        <li>inherent vice;</li>
                        <li>
                          fraud or infidelity by you, the shipper or consignee;
                        </li>
                        <li>
                          misrepresentation / false information by you, the
                          shipper or consignee;
                        </li>
                        <li>cyber attacks;</li>
                        <li>illicit trade;</li>
                        <li>
                          capture, seizure, arrest or detainment of goods by
                          public authority;
                        </li>
                        <li>nuclear contamination;</li>
                        <li>
                          rust, oxidation, discoloration, scratching, marring,
                          denting, chipping and/or electrical or mechanical
                          derangement to used goods, whether or not caused by an
                          insured peril;
                        </li>
                        <li>
                          Consequential and indirect damages, such as loss of
                          market, depreciation, or diminution in value as a
                          result of repair
                        </li>
                      </ul>
                    </Col>
                    <Col xs={12} md={6}>
                      <ul>
                        <li>
                          improper, inadequate or otherwise unsuitable packing
                          or preparation of the cargo, provided this exclusion
                          will not apply to the extent that: (i) such packing or
                          preparation was carried out by a third party other
                          than you, the shipper, consignee or anyone bearing an
                          interest in the cargo; and (ii) the deficiency was
                          unknown to you, the shipper, consignee and anyone
                          bearing an interest in the cargo;
                        </li>
                        <li>
                          fraud or infidelity by you, the shipper or consignee;
                        </li>
                        <li>
                          misrepresentation / false information by you, the
                          shipper or consignee;
                        </li>
                        <li>
                          a shipment of cargo being re-routed, stopped in
                          transit or retrieved at a point other than the
                          original consigned delivery point pursuant to any
                          instruction or representation to the transport carrier
                          by a fraudster or imposter;
                        </li>
                        <li>
                          a shipment of cargo being sent as a result of fraud or
                          trick upon the Customer, the shipper and/or consignee
                          (including but not limited to product orders made by
                          imposters); and
                        </li>
                        <li>
                          package labels being changed or revised in the course
                          of transportation for the purpose of fraudulent
                          redirection.
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </li>
              </ol>
            </li>
            <li>
              <b>CLAIM REPORTING LIMITATION {"&"} CLAIM PROCESS:</b>&nbsp;
              Pursuant to procedures established by Channel Partner and approved
              by UPSCIA from time to time, immediately report to Channel Partner
              or UPSCIA, as applicable, in writing any loss or damage to an
              insured shipment of cargo. As a condition precedent for coverage
              under the Policies, claims must in all events be submitted in
              writing within the following timeframes: (i) in the event of a
              claim for concealed loss or damage, within 30 days from the date
              of delivery; or (ii) for all other claims, within nine months from
              the date of delivery. In the event of a claim for non-delivery,
              the time-for-claim shall run from the date that the cargo was
              scheduled to have been delivered or should have reasonably been
              delivered, whichever is first in time. Loss verification will be
              required. You should take photos of any damaged goods, packaging
              and/or containers. Damaged goods, packaging and/or containers
              should be retained for inspection at the discretion of UPSCIA
              and/or the Insurer. By submitting any claim under a Policy, you
              agree to fully cooperate with Channel Partner, other Program
              Partners, UPSCIA and/or the Insurer in providing all documentation
              and information pertinent to such claim, including an examination
              under oath if requested by the Insurer. At the direction of the
              named insured on the applicable Policy, we will remit proceeds of
              claims payable under the Policies directly to you as a loss payee
              pursuant to remittance instructions you provide. In all other
              cases, we will remit claim proceeds to Channel Partner (or, if
              applicable, to another Program Partner), and Channel Partner (or,
              if applicable, such other Program Partner) will be solely
              responsible for ensuring that such proceeds are paid to you
            </li>
            <li>
              <b>NOTICE OF FULL AND ADDITIONAL TERMS:</b>&nbsp; Under all
              circumstances, the terms and conditions set forth in the
              applicable Policy shall control and determine insurance coverage.
              To the extent any terms and conditions stated herein conflict with
              those in any Policy, the Policy shall control and be binding as to
              issues of coverage under such Policy. UPSCIA reserves the right to
              change Insurers and to allow insuring terms for coverage to be
              modified in at any time and without notice to you, provided that
              coverage shall always substantially adhere to the summary herein
              and shall absent notice be without interruption.
            </li>
            <li>
              <b>DAMAGES AND WARRANTIES:</b>
              <ol type="a">
                <li>
                  <b>
                    Limitation of Direct Damages; Disclaimer of Indirect
                    Damages:
                  </b>
                  &nbsp; The cumulative aggregate liability of UPSCIA and its
                  affiliates for all direct losses, claims, suits,
                  controversies, breaches or damages for any cause whatsoever (
                  <b>Loss</b>) and regardless of the form of action or legal
                  theory shall be limited to the total insured value amount
                  declared during the shipment booking process for the shipment
                  at issue in the Loss, less (i) any amount(s) recovered or
                  recoverable from any other party; (ii) any insurance proceeds
                  that reduce the amount of the Loss payable under the
                  applicable Policy or any other policy of insurance; and/or
                  (iii) any amount(s) recovered or recoverable from any third
                  party with respect to the Loss. Nothing in the foregoing shall
                  limit End User’s rights to claims for shipment loss or damage
                  properly payable under the applicable Policy. UPSCIA IS NOT
                  LIABLE TO END USER FOR INDIRECT, INCIDENTAL, CONSEQUENTIAL,
                  EXEMPLARY, PUNITIVE, OR SPECIAL DAMAGES, INCLUDING LOST
                  PROFITS, REGARDLESS OF THE FORM OF THE ACTION OR THE THEORY OF
                  RECOVERY, AND REGARDLESS OF WHETHER SUCH DAMAGES WERE
                  FORESEEABLE OR WHETHER UPSCIA OR ANY PERSON OR ENTITY HAS BEEN
                  ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                </li>
                <li>
                  <b>Warranties:</b>&nbsp; EXCEPT AS OTHERWISE EXPRESSLY STATED
                  IN THESE T{"&"}Cs AND THE APPLICABLE POLICY, UPSCIA MAKES NO
                  WARRANTIES, EITHER EXPRESS OR IMPLIED, OF ANY KIND. EXCEPT AS
                  OTHERWISE EXPRESSLY STATED IN THESE T{"&"}Cs AND THE
                  APPLICABLE POLICY, END USER EXPRESSLY DISCLAIMS, AND EXPRESSLY
                  WAIVES, ANY AND ALL WARRANTIES, INCLUDING, WITHOUT LIMITATION,
                  THOSE OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.
                  NO DESCRIPTIONS OR SPECIFICATIONS, WHETHER OR NOT INCORPORATED
                  INTO THESE T{"&"}Cs AND THE APPLICABLE POLICY, SHALL
                  CONSTITUTE WARRANTIES OF ANY KIND.
                </li>
              </ol>
            </li>
            <li>
              <b>FURTHER ACKNOWLEDGEMENTS:</b>&nbsp; End User acknowledges and
              agrees that UPSCIA is the insurance producer through which each
              Policy was issued. End User further acknowledges and agrees that
              the Insurer and UPSCIA are the <b>only</b> parties who determine
              Policy coverages, exclusions and limitations, underwrite Policies,
              set insurance-related fees, collect insurance-related fees (except
              to the extent such fees are collected by Channel Partner or
              another Program Partner), adjust insurance claims under the
              Policies and issue insurance claim payments (
              <b>Insurance-Related Activities</b>). End User expressly
              acknowledges and agrees that no other party manages, controls or
              contributes in any way to the Insurance-Related Activities or
              decisions made pertaining to the Insurance-Related Activities.
            </li>
            <li>
              <b>EFFECTIVENESS; GOVERNING LAW:</b>&nbsp; These T{"&"}Cs shall
              become effective when accepted (or deemed to have been accepted)
              by you and shall be governed by and construed in accordance with
              the internal laws of the State of Georgia, without regard to its
              conflict of laws principles.
            </li>
            <li>
              <b>AGREEMENT TO ARBITRATE CLAIMS:</b>&nbsp; End User and UPSCIA
              agree that, except for disputes that qualify for state courts of
              limited jurisdiction (such as small claims, justice of the peace,
              magistrate court, and similar courts with monetary limits on their
              jurisdictions over civil disputes), any controversy or claim
              between any person or entity, whether at law or equity, arising
              out of or related to any Policy and/or coverage of shipments
              thereunder, regardless of the date of accrual of such dispute,
              shall be resolved in its entirety by individual (not classwide nor
              collective) binding arbitration. Arbitration is the submission of
              a dispute to a neutral arbitrator, instead of a judge or jury, for
              a final and binding decision, known as an “award.” Arbitration
              provides for more limited discovery than in court, and is subject
              to limited review by courts. Each party has an opportunity to
              present evidence to the arbitrator in writing or through
              witnesses. An arbitrator can only award the same damages and
              relief that a court can award under the law and must honor these T
              {"&"}Cs.
              <br />
              <br />
              Any controversy or claim between any person or entity, whether at
              law or equity, arising out of or related to the Program, a Policy
              and/or coverage of shipments thereunder shall be resolved solely
              based on these T{"&"}Cs and the applicable Policy.
              <br />
              <br />
              <ol type="a">
                <li>
                  <b>Institutional Arbitration:</b>&nbsp; The arbitration shall
                  be conducted by the American Arbitration Association (AAA) in
                  accordance with its Commercial Arbitration Rules and the
                  Supplementary Procedures for Consumer-Related Disputes (
                  <b>Rules</b>), and judgment on the award may be entered in any
                  court of competent jurisdiction. The Rules, including
                  instructions for how to initiate arbitration, are available at
                  http://www.adr.org or by calling the AAA at 1-800-778-7879.
                  The arbitrator shall decide all issues of the case on the
                  basis of the applicable law, not equity. If you initiate
                  arbitration, you must serve the opposing parties or their
                  registered agent for service of process.
                  <br />
                  <br />
                  Any arbitration under these T{"&"}Cs will take place on an
                  individual basis; class, mass, consolidated or combined
                  actions or arbitrations or proceeding as a private attorney
                  general are not permitted. End User and UPSCIA each waive
                  their right to trial by jury. End User is further giving up
                  the ability to participate in a class, mass, consolidated or
                  combined action or arbitration.
                </li>
                <li>
                  <b>
                    Place of Arbitration/Number of Arbitrators/Costs of
                    Arbitration/Governing Law/Survival:
                  </b>
                  &nbsp; Any arbitration will take place in the county where End
                  User resides (or, notwithstanding Section 3 of these T{"&"}Cs,
                  solely with respect to an End User that does not reside in the
                  United States, Fulton County, Georgia) and will be determined
                  by a single arbitrator. Any filing fee or administrative fee
                  required of End User by the AAA Rules shall be paid by End
                  User to the extent such fee does not exceed the amount of the
                  fee required to commence a similar action in a court that
                  otherwise would have jurisdiction. For all non-frivolous
                  complaints, UPSCIA will pay the amount of such fee in excess
                  of that amount. The arbitrator will allocate the
                  administrative costs and arbitral fees consistent with the
                  applicable rules of the American Arbitration Association.
                  Reasonable attorney’s fees and expenses will be allocated or
                  awarded only to the extent such allocation or award is
                  available under applicable law.
                  <br />
                  <br />
                  All issues are for the arbitrator to decide, except that
                  issues relating to the scope, application, and enforceability
                  of the arbitration provision are for a court to decide. The
                  Federal Arbitration Act governs the interpretation and
                  enforcement of this provision. This agreement to arbitrate
                  shall survive termination of the Policies and/or End User’s
                  and UPSCIA’s agreement to be bound to these T{"&"}Cs.
                </li>
                <li>
                  <b>Severability:</b>&nbsp; Notwithstanding anything to the
                  contrary in the AAA Rules, if any part of this arbitration
                  provision is deemed invalid or ineffective for any reason,
                  this shall not affect the validity or enforceability of the
                  remainder of this arbitration provision, and the arbitrator
                  shall have the authority to amend any provisions deemed
                  invalid or ineffective to make the same valid and enforceable.
                </li>
                <li>
                  <b>Desk Arbitration:</b>&nbsp; For all disputes concerning an
                  amount less than fifteen thousand dollars ($15,000.00), End
                  User and UPSCIA shall submit their arguments and evidence to
                  the arbitrator in writing and the arbitrator shall make an
                  award based only on the documents; no hearing will be held
                  unless the arbitrator in his or her discretion, and upon
                  request of a party, decides it is a necessity to require an
                  in-person hearing. For a dispute governed by the AAA
                  Consumer-Related Disputes Supplementary Procedures, and
                  concerning an award between fifteen thousand dollars
                  ($15,000.00) and fifty thousand dollars ($50,000.00),
                  inclusive, UPSCIA shall pay End User’s filing fee under the
                  AAA Rules, provided that End User agrees that both parties
                  shall submit their arguments and evidence to the arbitrator in
                  writing and that the arbitrator shall make an award based only
                  on the documents, without a hearing being held.
                  Notwithstanding this provision, the parties may agree to
                  proceed with desk arbitration at any time.
                </li>
                <li>
                  <b>Access to Small Claims Courts:</b>&nbsp; All parties shall
                  retain the right to seek adjudication in a state court of
                  limited jurisdiction, such as small claims, justice of the
                  peace, magistrate court, and similar courts with monetary
                  limits on their jurisdiction over civil disputes, for
                  individual disputes within the scope of such court’s
                  jurisdiction.
                </li>
                <li>
                  <b>Acknowledgements:</b>&nbsp; End User and UPSCIA acknowledge
                  and agree that pursuant to this Agreement to Arbitrate Claims:
                  <br />
                  <br />
                  <ol type="a">
                    <li>
                      END USER AND UPSCIA AGREE THAT EACH IS WAIVING THE RIGHT
                      TO HAVE A TRIAL BY JURY TO RESOLVE ANY DISPUTE ALLEGED
                      AGAINST END USER, UPSCIA, OR ANY PERSON OR ENTITY IN
                      CONNECTION WITH ANY INSURANCE POLICY AND/OR COVERAGE OF
                      SHIPMENTS THEREUNDER;
                    </li>
                    <li>
                      END USER AND UPSCIA AGREE THAT EACH IS WAIVING THE RIGHT
                      TO HAVE A COURT, OTHER THAN A STATE COURT OF LIMITED
                      JURISDICTION AS DEFINED ABOVE, RESOLVE ANY DISPUTE ALLEGED
                      AGAINST END USER, UPSCIA, OR ANY PERSON OR ENTITY IN
                      CONNECTION WITH ANY INSURANCE POLICY AND/OR COVERAGE OF
                      SHIPMENTS THEREUNDER;
                    </li>
                    <li>
                      END USER AND UPSCIA AGREE THAT EACH IS WAIVING THE RIGHT
                      TO HAVE A COURT REVIEW ANY DECISION OR AWARD OF AN
                      ARBITRATOR, WHETHER INTERIM OR FINAL, EXCEPT FOR APPEALS
                      BASED ON THOSE GROUNDS FOR VACATUR EXPRESSLY SET FORTH IN
                      SECTION 10 OF THE FEDERAL ARBITRATION ACT; AND
                    </li>
                    <li>
                      END USER AND UPSCIA AGREE THAT EACH IS WAIVING THE RIGHT
                      TO SERVE AS A REPRESENTATIVE, AS A PRIVATE ATTORNEY
                      GENERAL, OR IN ANY OTHER REPRESENTATIVE CAPACITY, JOIN AS
                      A CLASS MEMBER, AND/OR TO PARTICIPATE AS A MEMBER OF A
                      CLASS OF END USERS IN ANY CLASS, MASS, CONSOLIDATED OR
                      COMBINED ACTION OR ARBITRATION FILED AGAINST END USER,
                      UPSCIA, OR ANY PERSON OR ENTITY IN CONNECTION WITH THE
                      POLICIES AND/OR COVERAGE OF SHIPMENTS THEREUNDER.
                    </li>
                  </ol>
                </li>
                <li>
                  <b>Award:</b>&nbsp; The arbitrator may award money or
                  equitable relief in favor of only the individual party seeking
                  relief and only to the extent necessary to provide relief
                  warranted by that party’s individual claim. Similarly, an
                  arbitration award and any judgment confirming it apply only to
                  that specific case; it cannot be used in any other case except
                  to enforce the award itself. To reduce the time and expense of
                  the arbitration, the arbitrator will not provide a statement
                  of reasons for his or her award unless a brief explanation of
                  the reasons is requested by one of the parties. Unless both
                  End User and UPSCIA agree otherwise, the arbitrator may not
                  consolidate more than one person’s claims, and may not
                  otherwise preside over any form of a representative, private
                  attorney general or class proceeding.
                </li>
                <li>
                  <b>Confidentiality of Arbitration:</b>&nbsp; Notwithstanding
                  anything to the contrary in the AAA Rules, End User and UPSCIA
                  agree that the filing of arbitration, the arbitration
                  proceeding, any documents exchanged or produced during the
                  arbitration proceeding, any briefs or other documents prepared
                  for the arbitration, and the arbitral award shall all be kept
                  fully confidential and shall not be disclosed to any other
                  person or entity, except to the extent necessary to enforce
                  this arbitration provision, arbitral award or other rights of
                  the parties, or as required by law or court order. This
                  confidentiality provision does not foreclose the American
                  Arbitration Association from reporting certain consumer
                  arbitration case information as required by state law.
                </li>
              </ol>
            </li>
            <li>
              <b>CONTACT US:</b>&nbsp; If you have questions or want more
              information about the Policies, the Program, insurance coverage,
              pricing, the claims process and documents or any issues discussed
              in these T{"&"}Cs, email UPSCIA at{" "}
              <a href="mailto:isconnect@ups.com">isconnect@ups.com</a>.
            </li>
          </ol>
        </Container>
      </section>
    </main>
  );
};

export default Terms;
